/** Selectors / helpers over the auth store. */
import { useAuthStore, can as canFn } from '../store/auth';

export function useMe() {
  return useAuthStore((s) => s.user);
}

export function useNavigation() {
  return useAuthStore((s) => s.navigation);
}

export function usePermissions() {
  return useAuthStore((s) => s.permissions);
}

export function useActiveClient() {
  const id = useAuthStore((s) => s.activeClientId);
  const user = useAuthStore((s) => s.user);
  return user?.clients?.find((c) => c.id === id) || null;
}

/**
 * Reactive permission check.
 *
 * Defaults `scope.clientId` to the user's active client so that
 * client_user / client_admin permissions (which are stored under
 * `client_permissions[clientId]`, not the global `permissions` list)
 * are honored automatically by the sidebar and other UI gates. Pass an
 * explicit `scope` to override (e.g. `{ projectId }` for project-level
 * permission checks, or `{ clientId: null }` to opt out).
 */
export function usePermission(perm, scope) {
  return useAuthStore((s) => {
    const effectiveScope = scope === undefined
      ? { clientId: s.activeClientId }
      : scope;
    return canFn(s, perm, effectiveScope || {});
  });
}
